import * as React from 'react';
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

interface Props {
  mobile?: boolean
}

export const HeroContent: React.SFC<Props> = (props) => (
    <Container text style={{ 
      marginBottom: props.mobile ? '2em' : '0em'
    }}>
      <Header
        as='h1'
        content='Create and sell products, not companies!'
        inverted
        style={{
          fontSize: props.mobile ? '2.5em' : '4em',
          fontWeight: 'normal',
          marginTop: props.mobile ? '1.5em' : '2em',
        }}
      />
      <Header
        as='h2'
        content='Connect with other driven individuals to create and launch your next product with little to no upfront capital'
        inverted
        style={{
          fontSize: props.mobile ? '1.3em' : '1.7em',
          fontWeight: 'normal',
          marginTop: props.mobile ? '0.5em' : '1.5em',
        }}
      />
      <Button as={Link} to="/sign-up" primary size='huge' style={{ marginTop: "1em" }}>
        Sign Up Now
        <Icon name='arrow right' />
      </Button>            

    </Container>
  )
  


// WEBPACK FOOTER //
// ./src/home/HeroContent.tsx